
export function findNodeByKeyDFS(key: string, tree: Array<any>) {
    const stack = [...tree];
    while (stack.length > 0) {
        const node = stack.pop();
        if (node?.rowKey === key) {
            return node;
        }
        if (node?.data?.children && node?.data?.children?.length>0) {
            stack.push(...node?.data?.children);
        }
    }
    return null;
}


export function flattenStatusItemsIterative(treeList: any[], condition: (node: any) => boolean): any[] {
  let result = [];
  let stack = [...treeList];

  while (stack.length > 0) {
    const node = stack.pop();

    if (condition(node)) {
      result.push(node);
    }

    if (node?.data?.children && node?.data?.children?.length > 0) {
      stack.push(...node?.data?.children);
    }
  }

  return result;
}